/* =====================================================================
   X4 — THE NAME IN THE CARTOUCHE IS EDITABLE

   Tommy (IDEAS #22.2): "It could be as simple as letting you change the
   works of Tommy Long (the Tommy Long part) to someone else's GitHub
   handle and having it redraw. Maybe if you click it, it's just editable.
   Nice, simple, cool entry-level Easter egg."

   THE NAME IS PRINTED TYPE AND IT STAYS PRINTED TYPE. The cartouche is
   rastered into the furniture texture with everything else on the sheet,
   and a name set in DOM over a printed cartouche is a name in a different
   ink at a different weight (R21 measured exactly how different). So:

     at rest          the printed name is the only name. This module lays
                      ONE transparent box over it — the same device the
                      year index uses, `Room.onPaperQuad` — and the box
                      says nothing about itself but the cursor.
     while editing    the printed name is BLANKED (opacity 0 in the string,
                      never deleted — deleting moves pixels three hundred
                      units away; index.js measured that too) and the
                      furniture is rastered again, and the DOM editor is
                      the name, in the cartouche's own face at the
                      cartouche's own size.
     when it lands    the furniture is rastered a third time with the new
                      name IN IT, and the editor goes. The name on the
                      sheet is printed type again.

   THE FIT IS DIFF 0 because `prepFurniture` returns the string UNTOUCHED
   until one of those two things is true. A reader who never clicks the
   cartouche is looking at exactly the sheet that was there before this
   item, and nothing is fetched.
   ===================================================================== */
(function () {
'use strict';

if (/[?&]cart=0\b/.test(location.search)) return;

/* ---- WHERE THE PRINTED NAME IS ------------------------------------
   Read straight off src/img/sheet-frame.svg's `sv-cartouche` group, in the
   OVER LAYER's units — index.js's three numbers, which are the group's own
   transform="scale(1.297476) translate(-49,-51.890625)". */
var OVER = { k: 1.297476, dx: -49, dy: -51.890625 };
function sheetX(x) { return (x + OVER.dx) * OVER.k; }
function sheetY(y) { return (y + OVER.dy) * OVER.k; }

/* the cartouche's inner rule is x 811.2496 for 297.5008; the eyebrow's
   baseline is 920.66, the name's 948.5544 and the divider 961.23 — so the
   name's own band is the twenty-eight units between the eyebrow and the
   divider. `CU` is the group's own --cu, and the name is 40px * CU. */
var CU = 0.771, NAME_PX = 40, RULE = { x: 811.2496, w: 297.5008 };
var BOX = { x: RULE.x, y: 924, w: RULE.w, h: 30 };
var BASE = 948.5544 - BOX.y;            /* the baseline, inside the box */
var SPACING = 0.07;                     /* em, .sv-cart-name */
var FIT_W = RULE.w - 14;                /* the name keeps the rule's margin */
/* THE ELEMENT'S ORIGIN stands ABOVE the cartouche: the panel's foot is at
   980 and the paper's own edge is a few units below that (measured,
   X4-lost.png). The band above the panel held the sheet's remark lines
   once; CX1 took every line away and the origin stays where it was. */
var LINE = { y: 875, h: 14 };
/* X6 (d): THE EYEBROW'S BASELINE, which the selection wash may not cross.
   `A SURVEY OF THE WORKS OF` is set on 920.66 (the cartouche's own figure,
   two leaves up in this file) and it is small caps, so it has nothing
   below that line; a wash whose top edge sits on 920.66 + GAP is clear of
   it with paper showing between.

   THE GAP IS THREE UNITS AND THAT IS MEASURED, not chosen: the printed
   letters' antialiasing reaches about a device pixel below their baseline,
   so a cut ON the baseline leaves the band and the type touching. Three
   units is 4.0 device px at the fit, which is a clear strip of paper at
   the size the cartouche is actually read at. */
var EYE = 920.66, EYE_GAP = 3;
var TOP = LINE.y;                       /* the element's own origin */
/* CX1: the proofreader's deletion mark -- a loop with its tail carried
   up and out, the way a hand writes `dele` in a margin. One path, the
   revision red, drawn in a 10 x 12 box and scaled by CSS to the name. */
var DELE_SVG = '<svg viewBox="0 0 10 12" aria-hidden="true" focusable="false">' +
  '<path d="M1.2 8.6c0-2.6 2.1-4.4 4-4.4 1.6 0 2.6 1 2.6 2.2 0 1.5-1.4 2.6-3 2.6-1.3 0-2.2-.8-2.2-1.8 0-1.2 1.2-2 2.6-1.4 1.6.7 2.7 2.4 3.6 4.6M6.9 1.1c-.9 1.5-1.4 3-1.7 4.6"/>' +
  '</svg>';
var OFF = 0;                            /* the name box, inside it */

var Q = new URLSearchParams(location.search);
var TUNE = parseFloat(Q.get('cart'));   /* ?cart=<dy> nudges the baseline */
if (!isFinite(TUNE)) TUNE = 0;

var S = null, root = null, hit = null, ed = null;
var dele = null, strike = null, guest = null;
var mat = '', laid = 0, editing = false, asking = false;
var subject = null;                     /* null while it is his own sheet */
var printed = null;                     /* the name printed in the cartouche */
/* PH9: the phone's held press on the name shares the sheet (below) */
var PHONE_SHARE = /(^|\s)phone(\s|$)/.test(document.documentElement.className) &&
                  !!(navigator.share);
var printedRaw = null;                  /* and in the case it arrived in (R69) */

/* ==== S-B2 / CX1: THE WAY BACK IS ON THE CARTOUCHE, AND NOTHING IS SAID
   Tommy, review of 2026-09-19: "I'm not happy with that way back! ... we
   literally have a UI for setting the handle, and you probably would have
   done it before you even unlocked the terminal."

   And 2026-09-20, of every line of text this file ever put on the paper
   (the struck name, then a pencilled "back to Tommy Long's sheet", the
   "asking GitHub" wait, the "no GitHub account" miss, the "record is
   back" remark): "all of the lines of text suck and there shouldn't be
   any lines of text, including loading messages". So there are none. The
   cartouche speaks in its own correction language and nothing else:

   ASKING   the typed name stays as it is, half-toned (.is-asking).
   FOUND    the stranger's name prints in the cartouche's ink.
   NOT FOUND the typed name is struck through in the revision red and
            rubbed out, and the printed name returns. That is the whole
            of the miss; the api's reason still reaches the terminal's
            `handle` word, never the sheet.
   THE WAY BACK a proofreader's deletion mark, small, red, at the east end
            of a stranger's printed name, shown while a hand is over the
            name. Clicking it strikes the name through, rubs it out and
            reprints the surveyor's own (`Room.load(null)`, the terminal's
            `handle reset` call). An EMPTY cartouche committed does the
            same, because a name rubbed out is a record put aside.
   BACK     nothing said. The record changing is the message.
   ================================================================== */
/* ---- THE NAME HAS TO FIT THE CARTOUCHE -----------------------------
   "TOMMY LONG" is ten letters and the panel was cut for ten letters. A
   stranger's name is whatever it is, so the size is measured rather than
   guessed: the page's own face, through a 2d context, at the spacing the
   cartouche sets — and the size is only ever reduced, never raised. */
var meas = null;
function widthOf(text, px) {
  if (!meas) meas = document.createElement('canvas').getContext('2d');
  try { meas.letterSpacing = (SPACING * px).toFixed(3) + 'px'; } catch (e) { /* older */ }
  meas.font = px + 'px "Sorts Mill Goudy LN", "Sorts Mill Goudy", Georgia, serif';
  var w = meas.measureText(text).width;
  /* a context that will not do letterSpacing gets it added by hand */
  if (meas.letterSpacing === undefined) w += SPACING * px * text.length;
  return w;
}
function sizeFor(text) {
  var px = NAME_PX * CU;
  var w = widthOf(text, px);
  if (w > FIT_W && w > 0) px = px * FIT_W / w;
  return px;
}

/* =====================================================================
   R69 — AND THE NAME FITS THE CARTOUCHE

   Tommy, on the handle egg (2026-09-14): "can we expand the box we
   translate the name to, if you get what i mean? see 'RichardWatkins1'".
   The box is printed furniture and does not change shape, so it is the
   NAME that gives: a compositor's answer, not a joiner's.

   WHAT WAS ACTUALLY WRONG, measured on 8195 before a line was changed.
   `sizeFor` above was right and the string it was written into was not.
   The cartouche's own CSS is `font-size: calc(40px * var(--cu))` with
   --cu 0.771, so the cut size is 30.84 units IN THE GROUP'S OWN UNITS,
   and `sizeFor` measures and returns that same unit. prepFurniture then
   wrote the reduced size back as `font-size: (px / CU) px`, and an inline
   font-size is not multiplied by --cu — it is the unit itself. So every
   name that had been shrunk to fit was blown straight back up by
   1/0.771 = 1.2971, and the arithmetic cancelled: FIT_W / CU = 367.7
   units, the same width WHATEVER the name.

     RICHARD WATKINS  341.31 units at the cut size -> set at 367.78
     LINUS TORVALDS   306.72                       -> set at 367.80
     30 characters    699.65                       -> set at 367.41
     39 characters    865.30                       -> set at 367.52

   against an inner rule 297.5008 wide: 70.2 units over the rule, 35.1
   past each volute, 98 device px at his fit (R69-BEFORE-fit-richard.png).
   TOMMY LONG is 248.52 and never entered the branch, which is why the
   fault only ever showed on somebody else's sheet.

   WHAT IT DOES NOW: one line at the size that fits FIT_W, down to a
   FLOOR of half the cut size; below the floor the name is BROKEN and set
   on TWO lines at the largest size the band will take, which is ABOVE the
   one-line floor, so the break buys size back rather than spending it;
   and when two lines at the floor still will not hold it, each line is
   cut with the face's own ellipsis. NO VALID GITHUB HANDLE REACHES THE
   ELLIPSIS — 39 is GitHub's maximum and 39 characters set on two lines at
   16.92 units with 13.6 device px of paper to spare (R69-AFTER-fit-n39).
   Only a display NAME can be long enough; GitHub allows 255 of those.

   THE FLOOR IS HALF THE CUT SIZE and that is measured, not chosen: 15.42
   units is 21.5 device px at his fit (1 unit = 1.397 device px there,
   from the laid element's own 237.56 css px over BOX.w = 297.5) and 1.82x
   the printed eyebrow above it, which is set at 11px * CU = 8.48 units
   and reads. The name is the cartouche's principal line, and the floor is
   where it stops out-ranking its own eyebrow.

   THE BAND THE TWO LINES SIT IN is X6 (d)'s band: the eyebrow's baseline
   920.66 plus that item's three units of clear paper = 923.66 at the top,
   the divider 961.23 less the same three = 958.23 at the foot. The face's
   metrics off the page's own 2d context at 100px: cap height 0.71, and a
   capital Q's tail 0.19 under the baseline (the only capital here that
   descends; O overshoots 0.02). At a leading of 1.12 the block is 2.02
   sizes tall, so 34.57 / 2.02 = 17.11 units is the largest two lines fit;
   under that the block is centred in the band, not hung from it.
   ===================================================================== */
var FLOOR = NAME_PX * CU / 2;           /* 15.42 units — half the cut size */
var DIV = 961.23, DIV_GAP = EYE_GAP;    /* the divider, and the paper under */
var BAND = { top: EYE + EYE_GAP, bot: DIV - DIV_GAP };
var CAP = 0.71, QTAIL = 0.19, LEAD = 1.12;   /* measured; chosen */
var TWO_MAX = (BAND.bot - BAND.top) / (CAP + LEAD + QTAIL);

/* WHERE A NAME MAY BE BROKEN. The raw name, in the case it arrived in —
   `printed` is upper-cased for the cartouche and upper case has no camel
   boundary left in it, so the break is read off the original. */
function breaksIn(raw) {
  var out = [], i, p, c;
  for (i = 1; i < raw.length; i++) {
    p = raw.charAt(i - 1); c = raw.charAt(i);
    if (/\s/.test(c)) continue;
    if (/\s/.test(p)) out.push(i);                       /* after a space */
    else if (/[-_.]/.test(p)) out.push(i);               /* after a hyphen */
    else if (/[a-z0-9]/.test(p) && /[A-Z]/.test(c)) out.push(i);  /* camel */
    else if (/[A-Za-z]/.test(p) && /[0-9]/.test(c)) out.push(i);  /* a figure */
  }
  return out;
}
/* AND WHICH BREAK. The card's letter is "its last capital or digit
   boundary"; taken literally that sets RichardWatkins1 as RICHARDWATKINS
   over 1, which is a compositor leaving a single figure on a line and no
   compositor does. So of the boundaries the one that BALANCES is taken —
   the smallest longer-line — and the LAST of any that tie, which is the
   card's rule wherever balance does not decide. */
function splitTwo(raw) {
  var cand = breaksIn(raw), best = null, i, px = NAME_PX * CU;
  for (i = 0; i < cand.length; i++) {
    var a = raw.slice(0, cand[i]).replace(/[\s-_.]+$/, ''), b = raw.slice(cand[i]).replace(/^\s+/, '');
    if (!a || !b) continue;
    var w = Math.max(widthOf(a.toUpperCase(), px), widthOf(b.toUpperCase(), px));
    if (!best || w <= best.w) best = { w: w, a: a.toUpperCase(), b: b.toUpperCase() };
  }
  return best;
}
/* A LINE THAT WILL NOT HOLD AT THE FLOOR IS CUT. The face has its own
   ellipsis (U+2026, 0.756 em here) and it is the face's, not three full
   stops, because the cartouche is set type. */
function clip(text, px) {
  if (widthOf(text, px) <= FIT_W) return text;
  var t = text;
  while (t.length > 1 && widthOf(t + '…', px) > FIT_W) t = t.slice(0, -1);
  return t.replace(/\s+$/, '') + '…';
}

/* THE WHOLE ANSWER FOR ONE NAME: the size it is set at, and the one or
   two lines with the baseline each stands on. */
function layoutName(raw) {
  var one = String(raw).toUpperCase(), px = sizeFor(one);
  if (px >= FLOOR) return { px: px, lines: [{ t: one, y: null }] };   /* y: the printed baseline */
  var two = splitTwo(String(raw));
  if (two) {
    var s = Math.min(TWO_MAX, NAME_PX * CU * FIT_W / two.w);
    var cut = s < FLOOR;
    if (cut) s = FLOOR;
    var top = BAND.top + ((BAND.bot - BAND.top) - (CAP + LEAD + QTAIL) * s) / 2;
    var b1 = top + CAP * s, b2 = b1 + LEAD * s;
    return { px: s, cut: cut,
             lines: [{ t: cut ? clip(two.a, s) : two.a, y: b1 },
                     { t: cut ? clip(two.b, s) : two.b, y: b2 }] };
  }
  return { px: FLOOR, cut: true, lines: [{ t: clip(one, FLOOR), y: null }] };
}

/* ---- THE FURNITURE'S OWN STRING ------------------------------------ */
function esc(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
var NAME_RE = /(<text[^>]*class="sv-cart-name"[^>]*>)([\s\S]*?)(<\/text>)/;

/* =====================================================================
   AND THE FIGURES IN THE MARGIN ARE THE RECORD'S TOO

   Four of them, and a drawing. They are BAKED into sheet-frame.svg by
   room-e9/build-furniture.js off his own filed record, so a foreign record
   left them saying his numbers — which is not a cosmetic fault, it is the
   sheet telling a lie about the ground it is drawn over. build-furniture
   is not this item's to touch, so they are re-struck in the string on the
   way to the raster, from the field that has actually been loaded:

     the surveyed-to date   top left, "Surveyed to 11 September 2026"
     the range              top right, "January to September 2026"
     the directed day       bottom right, "A directed day now stands at 22…"
     the tally              bottom right, "7,425 marks levelled to date."
     THE SECTION            the profile along the foot of the sheet, and the
                            survey front ruled down it

   THE SECTION'S OWN SCALE, read back off the baked drawing and checked
   against his record (a probe in node, 271 points): x is the calendar,
   `X0 + B * (day + 0.5)`. B is 5.56042 units a day, from the month rules
   (JAN 2026 at 205.3286, FEB at 377.7013); X0 — the x of 1 Jan 2026 — is
   206.8876, which is the month labels' own x plus the 1.559 the whole
   baked profile is offset from them by (a constant, measured over all 271
   points, and the thing that puts the baked FRONT LINE on day 254 =
   12 Sep 2026 = the record's `today` exactly, not 254.28). y is the ROOT
   scale of the contours, `932 - sqrt(commits) * K`, K = 6.697263 from the
   figured rungs 5/45/125/245; and the value at a day is the MEAN OF THE
   WORKING DAYS in the seven days [d-5, d+1]. Re-run over his own record
   that rule reproduces the baked path to a mean absolute error of
   **0.056 commits**, which is the path's own one-decimal rounding — so the
   section a foreign record gets is drawn by the same arithmetic as the one
   printed on his.
   ===================================================================== */
var SEC = {
  X0: 206.8876, B: 5.56042,              /* x of 1 Jan 2026, and units a day */
  Y0: 932, K: 6.697263122599675,         /* the datum, and the root scale */
  FROM: '2025-12-15',                    /* the first point of the baked path */
  TOP: 810, BOT: 938                     /* the panel's clipped field */
};
var DAYMS = 86400000;
function dnum(iso) { return Math.round((Date.parse(iso + 'T00:00:00Z') - Date.parse('2026-01-01T00:00:00Z')) / DAYMS); }
function isoAt(n) { return new Date(Date.parse('2026-01-01T00:00:00Z') + n * DAYMS).toISOString().slice(0, 10); }
function secX(dayNo) { return SEC.X0 + SEC.B * (dayNo + 0.5); }
function secY(v) { return SEC.Y0 - Math.sqrt(Math.max(0, v)) * SEC.K; }

/* ==== R70: AND THE SECTION IS DRAWN ON THE SHEET'S SCALE, WITH THE
   RECORD'S OWN FIGURES UP THE SIDE.
   The panel's y is the root scale of the contours, so the profile has to
   be plotted in the same sheet commits the ground is — otherwise the
   section under a stranger's plate is a flat line beneath a country with
   mountains in it. The five figures baked up the side (0, 5, 45, 125,
   245) are heights, and they stay where they are: what is re-struck is
   what each of them is worth IN THIS RECORD'S COMMITS. The mean of the
   week's working days is a day-sized number and it is that number which
   goes up the ladder — the ladder places days. */
var SEC_FIGS = [0, 5, 45, 125, 245];
function ladder() {
  var sc = (window.Room && Room.sheetScale) ? Room.sheetScale() : null;
  return window.RoomField ? RoomField.ladder(sc)
                          : { id: true, to: function (c) { return c; }, from: function (v) { return v; } };
}
function secFig(v, lad) {
  if (lad.id || v === 0) return String(v);
  var r = lad.from(v);
  return r >= 10 ? String(Math.round(r)) : String(Math.round(r * 10) / 10);
}

/* the record's days, as one map, for the section and the tally */
var COUNTS = null, TALLY = 0;
function ingest(payload) {
  COUNTS = new Map(); TALLY = 0;
  var home = String(payload.home || '');
  Object.keys(payload.years || {}).forEach(function (y) {
    (payload.years[y].contributions || []).forEach(function (c) { COUNTS.set(c.date, c.count); });
    if (y === home) TALLY = payload.years[y].total[y] || 0;
  });
}

/* S3: THE VALUE AT A DAY, lifted out of sectionPath whole so the printed
   strike and the live one below are the SAME arithmetic and cannot drift
   apart: the mean of the working days in the seven days [d-5, d+1]. */
function meanAt(i, map) {
  var sum = 0, n = 0, k;
  for (k = -5; k <= 1; k++) {
    var d = new Date(Date.parse('2026-01-01T00:00:00Z') + (i + k) * DAYMS);
    var dow = d.getUTCDay();
    if (dow === 0 || dow === 6) continue;            /* working days only */
    var key = d.toISOString().slice(0, 10);
    if (!map.has(key)) continue;
    sum += map.get(key); n++;
  }
  return n ? sum / n : 0;
}

function sectionPath(surveyedTo) {
  if (!COUNTS) return null;
  var LAD = ladder();                                  /* R70 */
  var a = dnum(SEC.FROM), b = dnum(surveyedTo), out = [], i;
  if (!(b > a)) return null;
  for (i = a; i <= b; i++) out.push([secX(i), secY(LAD.to(meanAt(i, COUNTS)))]);
  var x0 = out[0][0], x1 = out[out.length - 1][0];
  var d0 = 'M' + x0.toFixed(1) + ' ' + SEC.Y0.toFixed(1);
  for (i = 0; i < out.length; i++) d0 += 'L' + out[i][0].toFixed(1) + ' ' + out[i][1].toFixed(1);
  return d0 + 'L' + x1.toFixed(1) + ' ' + SEC.Y0.toFixed(1) + 'Z';
}

/* =====================================================================
   S3 — AND THE SECTION IS LIVE

   Tommy, review 3: "the section should probably be live; it'd be weird
   for the map to change and the index of the years to change but the bit
   in the middle to be locked to 2026." It was locked because it is
   PRINT: `sectionPath` strikes the whole filed record into the frame SVG
   once and the frame SVG is a raster.

   MEASURED FIRST, because the honest way to make print live is to print
   it again, and that is `Room.refurnish()` — the whole 2364 x 1216 sheet
   re-cut, re-decoded and re-uploaded. On this box, headless with
   swiftshader: 62.5 ms cold (the SVG still warm in the http cache), then
   1542.4 and 1561.3 ms. A settle that costs a second and a half is not a
   settle, it is a stall — twenty-five times the 60 ms the brief allowed.
   So the section is NOT re-struck through the whole furniture. For a day
   it was a DOM overlay laid on the paper the way pin.js lays the clip —
   and that showed THROUGH the file card (whose paper is a mesh in the
   canvas), did not fold with the paper and took no lamp. Tommy,
   2026-09-19, to drawing it on the paper instead: "yes please". So it is
   PRINT AGAIN, struck small: the moving parts are rastered as one little
   SVG the size of the panel's own texels (from the same `meanAt` the
   print was struck from), composited over the pristine print of that
   region and put back into the furniture texture with `texSubImage2D`
   (`Room.furnPatch`, engine.js) — the same sheet, under the card,
   folding with the paper, lit by the lamp, and nothing else re-cut. The
   printed panel's moving parts are turned off in the raster ONCE
   (`blankSection`). The panel's frame, its rules, its datum, the sea
   band and the five figures up the side are all still print: none of
   them moves.

   MEASURED (headless swiftshader, 1440x900, dpr 1, other builders'
   Chromes on the box): the panel is 1244 x 101 texels at (50, 445) of
   a 1344 x 691 print. A strike is 6-56 ms whole -- markup 1-3 ms, the
   <img> raster 4-54, the composite and texSubImage2D 1-8 -- EXCEPT the
   first two in a page, 1.5 s and ~1 s, which is Chrome warming its
   SVG-image machinery and not the face: a plain page with no room
   loads a fontless test SVG in 2805 then 715 then 4 ms, and the same
   SVG with the frame's embedded face in 2-21 ms after that. The
   strike is asynchronous, so the warm-up costs no frame; the print
   simply keeps the previous section a second longer, once. Nothing
   else is re-cut: Room.refurnish() stays what it was and the section
   is re-applied on it by furnUpload.

   SL1, 2026-09-22 — AND IT FOLLOWS THE DRAG. Tommy: "does the section
   need to only rerender when we stop panning or could it dynamically
   redraw as we drag without sacrificing performance?" It only waited
   for the settle because of the paragraph above: the <img> raster was
   nearly the whole of the strike's cost, and the first two in a page
   cost a second and a half each. So the SVG is GONE — the same marks
   are drawn with Canvas 2D straight into the same scratch canvas
   `Room.furnPatch` was already handing the strike, through the same
   texSubImage2D, into the same texels. No markup, no Blob, no <img>, no
   decode, nothing asynchronous and nothing to warm up; the strike is
   now a function call, so it is made on ANY frame the span has moved
   (`lay`) and the settle is only the guarantee of a last one. The
   strata's lattice is cut once into a canvas of the panel's size and
   laid down under a clip (`hatchCache`), which is the difference
   between 17 ms and 2. MEASURED, at Tommy's own 2194 x 1234 dpr 1.75
   (3374 x 272 texels): 2.0 ms a strike, 1.2 of it the drawing and 0.8
   the composite and the upload, against 6-56 ms and a 1.5 s warm-up
   before. PROVED the same picture: struck both ways into two canvases
   of the panel and compared texel by texel, the profile, the front
   line, the horizon's rule and name, the month labels and the note
   differ on 610 of 917,728 texels (0.066%, mean 0.08 of 255) at the fit
   and 761 (0.083%) at a panned, tilted view — the labels are the
   frame's own face either way, registered with the page as a FontFace
   so a canvas can name it. What does differ is the strata's hatch: an
   SVG <pattern> rasterises its tile and tiles it, a canvas draws the
   lattice, so the ink lands on slightly different texels (4.7% of the
   ground band over a threshold of 24) though there is the same amount
   of it (mean alpha 10.23 against 10.05). At Tommy's scale the two are
   the same hatch in the same places; at half that scale the pattern's
   tiling smears where the canvas draws lines.

   WHAT FOLLOWS THE VIEW is the horizontal: the profile, the front line
   and the labels along the bottom are re-laid to the span of record
   under the current x-range. WHAT DOES NOT is the vertical. The panel's
   y is the root scale of the contours and the five figures are heights
   on that scale — re-scaling them to each view would make the section
   un-comparable with the ground drawn above it, and the whole point of a
   section is that it is in the same units as the plan. So a narrow view
   is a horizontal zoom and nothing else. That is a taste call and this
   is it written down.
   ===================================================================== */
/* ROOT UNITS, not the over layer's: `sv-section` sits at the root of
   sheet-frame.svg (viewBox 0 0 2364 1216), outside the `sv-over` group
   whose scale(1.297476) translate(-49,-51.890625) is what OVER and
   sheetX/sheetY undo for the cartouche and the year index. So the panel
   is laid the way pin.js lays the clip: its own numbers, unit 1. Laid
   through OVER it came out 1.3x too big and 170 units low, a second
   section sprawled across the whole foot of the paper (Tommy, 2026-09-19:
   "why do we now have 2 sections ... one behind the whole bottom of the
   paper"). */
var SEC_PANEL = { x: 88, y: 784, w: 2188, h: 176 };     /* the printed panel, root units */
var SEC_PLOT = null;
function secPlot() {
  /* REVIEW 2026-09-19, Tommy: "it juts out to the left of the 'zero value'
     of the x-axis". S3 plotted the live profile across the PRINTED path's
     own x-range, which begins at SEC.FROM (15 Dec 2025, x ~115) — ten
     units west of the panel's field, whose rules and datum run x 122 to
     2242 (sheet-frame.svg, .sv-section-rule). The print never showed it
     because its first fortnight was nought, flat on the datum; the live
     one carries real ground there. So the field is the rules' own span. */
  /* SB2 (2026-09-24): and it stops at 1900, west of the day's card. The card
     is sized in sheet units and lies over x ~1941 to the east edge at every
     window, so the section's east end was always under it (at sea, the
     harbour and the wreck). Tommy: "we don't reprint the panel, we just show
     the last X% of it as blank". The printed rules run on under the card. */
  /* SB4 (2026-10-01): AND THE SCALE IS THE SHEET'S AGAIN. SB2 did not blank
     the last of the panel: it squeezed the view's whole span into 122-1900,
     so the section ran at 0.84 of the sheet's scale (its months a fifth
     short of the plan's above) and the ground dropped to the datum at 1900,
     a visible cliff 40 units short of the card. Tommy, 2026-10-01: "the data
     for the section seems to randomly terminate before the file card". So
     the span is laid across the rules' own 122-2242 as it was, and the
     drawing is CUT at `cut`, under the card's west edge (1941, and ~7 more
     at the foot of the band for the card's tilt) — the ground runs on under
     the card and is blank beyond, which is the SB2 ruling. The note still
     ends west of the card, at `note`. */
  if (!SEC_PLOT) SEC_PLOT = { x0: 122, x1: 2242, cut: 1965, note: 1900 };
  return SEC_PLOT;
}

/* ---- WHOSE DAYS ------------------------------------------------------
   A stranger's record is already ingested (`setSubject`). HIS OWN never
   was: engine.js reads it straight out of the document and the handle
   only ever needed the name. The same two script tags are read here. */
var OWN = null, OWN_REC = null;
function readJSON(id) {
  var n = document.getElementById(id);
  if (!n) return null;
  try { return JSON.parse(n.textContent); } catch (e) { return null; }
}
function ownRecord() {
  if (OWN_REC !== null) return OWN_REC;
  OWN_REC = false;
  var rec = readJSON('survey-data');
  if (!rec) return OWN_REC;
  OWN = new Map();
  (rec.contributions || []).forEach(function (c) { OWN.set(c.date, c.count); });
  var hist = readJSON('survey-history') || {};
  Object.keys(hist).forEach(function (y) {
    ((hist[y] || {}).contributions || []).forEach(function (c) { OWN.set(c.date, c.count); });
  });
  OWN_REC = { today: rec.today || null, surveyedTo: rec.surveyedTo || null };
  return OWN_REC;
}
function liveCounts() { return subject ? COUNTS : (ownRecord() ? OWN : null); }

/* ---- N2: THE DATED HORIZONS, AND WHERE THEY FALL --------------------
   Tommy, 2026-09-20: "the section along the line of sheet has fable 5
   hardcoded onto it, basically it's not wired up to dynamically show
   markers based on the dates on show?" It was print: the generator ruled
   every horizon it could reach at the x of the PRINT'S OWN fixed span
   (18 Dec 2025 to 2 Jan 2027) and left it there, so a pan moved the
   calendar under the panel and the name stayed where it had been
   lettered — a model's release date pointing at the wrong week.

   They are struck live now, off the same `survey-horizons` the field is
   built from, at the x the struck span puts each date on. Nothing is
   named here: a horizon added to src/_data/horizons.json is ruled on the
   next settle, and one whose date is outside the view is not drawn. */
function liveHorizons() {
  var h = readJSON('survey-horizons');
  return (h && h.horizons) || [];
}
/* the room a name takes at HZ_PX, near enough to keep two of them apart:
   the face's capitals run about 0.66 em and the strike adds 0.05 em of
   letter-spacing. Generous on purpose — a gap too wide only stacks a
   name onto the second row, a gap too narrow overprints one name on
   another and neither can be read. */
var HZ_PX = 14;                     /* and the size .sv3-horizon is set at */
function horizonRoom(name) { return name.length * HZ_PX * 0.71 + 8; }

function liveDates() { return subject ? subject : (ownRecord() || null); }

/* ---- A DATE IS A PLACE, and the engine already knows where -----------
   `Room.cellOf(iso)` answers the CENTRE of the column a day falls in, so
   two calls a year apart give the column width exactly (52 columns to
   364 days) and one short walk back finds which day that column starts
   on. From those three numbers the inverse is exact — no private of the
   engine is read and nothing here has to know the record's epoch. */
var CAL = null;
function calib() {
  if (CAL) return CAL;
  if (!window.Room || !Room.cellOf) return null;
  var dt = liveDates();
  var probe = (dt && dt.today) || '2026-06-01';
  var n0 = dnum(probe), p0 = Room.cellOf(isoAt(n0)), first = n0, k, p;
  if (!p0) return null;
  for (k = 1; k <= 7; k++) {
    p = Room.cellOf(isoAt(n0 - k));
    if (!p) return null;
    if (Math.abs(p[0] - p0[0]) > 0.0001) break;
    first = n0 - k;
  }
  var far = Room.cellOf(isoAt(first - 364));
  if (!far) return null;
  var cw = (p0[0] - far[0]) / 52;
  if (!(cw > 0)) return null;
  CAL = { x0: p0[0], d0: first + 3.5, cw: cw };     /* a column's centre is its Thursday-ish middle */
  return CAL;
}
function dayOfX(mx) {
  var c = calib();
  return c ? c.d0 + ((mx - c.x0) / c.cw) * 7 : null;
}
function viewSpan() {
  if (!window.Room || !Room.centre) return null;
  var v = Room.centre();
  var a = dayOfX(v.x - v.w / 2), b = dayOfX(v.x + v.w / 2);
  if (a === null || b === null || !(b - a > 0.5)) return null;
  return [a, b];
}

/* ---- THE LABELS ALONG THE BOTTOM, re-laid to the span ---------------
   Years when the view holds more than about two and a half of them,
   months when it holds more than a quarter, and Mondays when it is
   tighter than that — fourteen at the most, which is what the sheet was
   printed with. The strings are dates and nothing else. */
function secTicks(a, b) {
  var span = b - a, out = [], i, st, thin;
  var n0 = Math.ceil(a), n1 = Math.floor(b);
  for (i = n0; i <= n1; i++) {
    var d = new Date(Date.parse('2026-01-01T00:00:00Z') + i * DAYMS);
    var dom = d.getUTCDate(), mon = d.getUTCMonth(), yr = d.getUTCFullYear();
    if (span > 900) { if (dom === 1 && mon === 0) out.push([i, String(yr)]); }
    else if (span > 70) {
      if (dom === 1) out.push([i, mon === 0 ? 'JAN ' + yr : SHORT[mon].toUpperCase()]);
    } else if (d.getUTCDay() === 1) out.push([i, dom + ' ' + SHORT[mon].toUpperCase()]);
  }
  if (!out.length && n1 >= n0) {
    var m = Math.round((a + b) / 2), dm = new Date(Date.parse('2026-01-01T00:00:00Z') + m * DAYMS);
    out.push([m, dm.getUTCDate() + ' ' + SHORT[dm.getUTCMonth()].toUpperCase()]);
  }
  if (out.length > 14) {
    st = Math.ceil(out.length / 14); thin = [];
    for (i = 0; i < out.length; i += st) thin.push(out[i]);
    out = thin;
  }
  return out;
}

/* THE INK, IN NUMBERS THE CANVAS CAN READ. Until SL1 this was a
   stylesheet: the strike was an SVG rastered through an <img>, and an
   SVG decoded through an <img> sees no stylesheet of the page's, so the
   rules that were `.sv3-*` in styles.css had to ride inside the markup
   and the face with them. SL1 draws the same marks with Canvas 2D, so
   the rules are numbers here instead of text — the SAME three greys and
   the coast brown as the frame, the same sizes, the same weights, the
   same lattice. The profile's stroke is non-scaling as the printed one
   was, 1.2 TEXELS whatever the layout, and so is the horizon's pecked
   hairline; in a context scaled to root units that is a width divided by
   the region's `k`. The front line and the hatch are NOT non-scaling and
   stay in root units, as the plate has them.

   N2: the horizon is in the plate's own dress — the contour's ink for
   the pecked hairline (`--contour`), the index contour's for the name
   (`--contour-idx`), both read off sheet-frame.svg so the struck horizon
   and a printed one are the same drawing. */
var INK = {
  profile: '#6d4520', profileW: 1.2,                  /* texels, non-scaling */
  strata: 'rgb(122,90,52)', strataW: 0.6, strataA: 0.7,
  unsurv: 'rgb(168,146,104)', unsurvW: 0.275, unsurvA: 0.42,   /* SB5 */
  month: '#55483a', monthPx: 9.5, monthTrack: 0.06,   /* em, as letter-spacing was */
  note: '#7d6d59', notePx: 14,
  hzLine: '#b8763f', hzLineW: 0.9, hzDash: [3.4, 2.2],/* texels, non-scaling */
  hz: '#97562a', hzPx: 14, hzTrack: 0.05
};

/* ---- THE PRINT'S OWN FACE, WHERE A CANVAS CAN REACH IT --------------
   The labels are set in the plate's Sorts Mill Goudy. Inside an SVG the
   face could ride in the markup as an @font-face; a canvas has no
   markup, and `ctx.font` can only name a family the PAGE's font set
   already holds. The page holds a 'Sorts Mill Goudy' of its own
   (styles.css) but it is NOT the same bytes: sheet-frame.svg carries a
   subset, 11,556 bytes against the served file's 22,804, and a subset
   can letter a word a hair differently from the whole cut. So the
   frame's own @font-face (fetched once by engine.js's `Room.printFace`,
   which the light line's strike shares) is handed to the page as a
   FontFace under a name of its own — the served face is left exactly as
   it was, and nothing else on the page changes face. `secFont` names the
   print's cut first and the page's as the fallback, so a glyph the
   subset does not carry is still lettered in Goudy and not in Georgia.
   The strike waits for the face, as it always did: a label struck in the
   wrong face would have to be struck again. */
var secFace = null, secFaceReq = 0, secFaceOn = 0;   /* 0 on its way, 1 in, -1 no face */
var PRINT_FAM = 'Sorts Mill Goudy Print';
function secFont(px) {
  return px + 'px "' + PRINT_FAM + '", "Sorts Mill Goudy", Georgia, serif';
}
function secFaceAdd(css) {
  var m = css && /url\(([^)]+)\)/.exec(css);
  if (!m || !window.FontFace || !document.fonts) { secFaceOn = -1; return; }
  var ff;
  try { ff = new FontFace(PRINT_FAM, 'url(' + m[1] + ')', { style: 'normal', weight: '400' }); }
  catch (e) { secFaceOn = -1; return; }
  ff.load().then(function () {
    document.fonts.add(ff); secFaceOn = 1; secKey = ''; onViewSettled();
  }, function () { secFaceOn = -1; secKey = ''; onViewSettled(); });
}
/* N1: the fetch is engine.js's `Room.printFace` -- the light line is
   struck with the same face, and one fetch serves both strikes. */
function secFaceLoad() {
  if (secFaceReq) return;
  secFaceReq = 1;
  var f = Room.printFace(function (face) {
    secFace = face; secFaceAdd(face);
    onViewSettled();     /* the strike that waited for the face, now */
  });
  if (f !== null) { secFace = f; secFaceAdd(f); onViewSettled(); }
}

/* ---- ONE LATTICE OF THE HATCH --------------------------------------
   `gap` apart, turned `deg` off the vertical about the DRAWING'S OWN
   origin, which is what `patternTransform` did: the lattice is a
   property of the sheet, not of the piece of it being hatched, so the
   two hatches lie in the same place whatever the span. Drawn as lines
   rather than as a tiled pattern because a lattice has no seams — and
   because an SVG <pattern> clips its tile, so each 0.6-unit line came
   out as the 0.3 of it that fell inside the tile. That clipped width is
   what the plate has shown since S3 and it is kept here: STRATA_W below
   is the visible half, and the line is centred where the tile's kept
   half stood. */
function hatch(ctx, deg, gap, x0, y0, x1, y1, w, off) {
  var t = deg * Math.PI / 180, c = Math.cos(t), s = Math.sin(t);
  var X = [x0, x1], Y = [y0, y1], i, j, u, v;
  var u0 = 1e9, u1 = -1e9, v0 = 1e9, v1 = -1e9;
  for (i = 0; i < 2; i++) for (j = 0; j < 2; j++) {
    u = X[i] * c + Y[j] * s; v = -X[i] * s + Y[j] * c;
    if (u < u0) u0 = u; if (u > u1) u1 = u;
    if (v < v0) v0 = v; if (v > v1) v1 = v;
  }
  var n0 = Math.floor(u0 / gap) - 1, n1 = Math.ceil(u1 / gap) + 1, p = new Path2D();
  for (i = n0; i <= n1; i++) { u = i * gap + off; p.moveTo(u, v0); p.lineTo(u, v1); }
  ctx.save();
  ctx.rotate(t);
  ctx.lineWidth = w;
  ctx.stroke(p);
  ctx.restore();
}

/* ---- AND THE HATCH IS DRAWN ONCE ------------------------------------
   The lattice is a property of the SHEET: it does not move with the
   span, only what is clipped out of it does. So both families are drawn
   once into a canvas the size of the panel's region and every strike
   clips the shape and lays that canvas down in one `drawImage` — which
   is the whole difference between a strike that costs 17 ms and one that
   costs 3. The alpha is baked in, and source-over is the same operation
   either way, so the picture is not changed by being kept. It is cut
   again if the print is re-cut at another size. */
var secHatch = null, secHatchKey = '';
var HATCH_W = 0.3, HATCH_O = 0.15;   /* the tile-clipped half of a 0.6 line, and where it stood */
function hatchCache(R) {
  var key = R.px + ',' + R.py + ',' + R.pw + ',' + R.ph + ',' + HATCH_W + ',' + HATCH_O;
  if (secHatch && secHatchKey === key) return secHatch;
  var C = document.createElement('canvas');
  C.width = R.pw; C.height = R.ph;
  var g = C.getContext('2d');
  g.setTransform(R.k, 0, 0, R.k, -R.px, -R.py);
  g.lineCap = 'butt'; g.lineJoin = 'miter';
  g.globalAlpha = INK.strataA;
  g.strokeStyle = INK.strata;
  hatch(g, 35, 6, SEC_PANEL.x, SEC_PANEL.y, SEC_PANEL.x + SEC_PANEL.w, SEC_PANEL.y + SEC_PANEL.h,
        HATCH_W, HATCH_O);
  hatch(g, -35, 7, SEC_PANEL.x, SEC_PANEL.y, SEC_PANEL.x + SEC_PANEL.w, SEC_PANEL.y + SEC_PANEL.h,
        HATCH_W, HATCH_O);
  secHatch = C; secHatchKey = key;
  return C;
}

/* ---- THE MOVING PARTS, DRAWN STRAIGHT INTO THE PRINT ----------------
   `R` is Room.furnRegion's answer for the panel and `ctx` is the scratch
   canvas `Room.furnPatch` has already laid the PRISTINE print of that
   region into. The context is scaled to ROOT units with the region's own
   origin taken off, so every number below is the number the plate is
   drawn in and each canvas pixel IS a texel of the sheet — which is what
   the SVG's viewBox did before it. The coordinates are rounded the
   markup's own way (a tenth of a unit on the profile, a hundredth on the
   rules and the labels) so that this is the same picture and not a
   near-enough one. */
function secCanvas(ctx, R, a, b, vs) {
  if (vs) return seaCanvas(ctx, R, a, b, vs);     /* TM1: out at sea, the passage */
  var map = liveCounts();
  if (!map) return false;
  var P = secPlot(), W = P.x1 - P.x0, lad = ladder(), k = R.k;
  /* SB4: the day at the cut, so everything struck stops under the card */
  var bc = a + (b - a) * ((P.cut - P.x0) / W);
  var N = Math.max(2, Math.min(640, Math.ceil(bc - a))), i, xs = [], ys = [];
  for (i = 0; i <= N; i++) {
    /* west of the record, and out on the sea, every day is absent and the
       mean is nought — which is the datum, drawn flat. Nothing special
       is done about it because nothing needs to be. */
    xs.push(+(P.x0 + (P.cut - P.x0) * (i / N)).toFixed(1));
    ys.push(+secY(lad.to(meanAt(Math.round(a + (bc - a) * (i / N)), map))).toFixed(1));
  }
  ctx.setTransform(k, 0, 0, k, -R.px, -R.py);
  ctx.lineJoin = 'miter'; ctx.miterLimit = 4; ctx.lineCap = 'butt';
  /* the shape: the ground, shut down on to the datum at either end. It is
     the line that is drawn AND the clip the strata are hatched inside —
     one shape, two places, as the baked file has it. */
  var shape = new Path2D();
  shape.moveTo(+P.x0.toFixed(1), SEC.Y0);
  for (i = 0; i <= N; i++) shape.lineTo(xs[i], ys[i]);
  shape.lineTo(+P.cut.toFixed(1), SEC.Y0);
  shape.closePath();

  ctx.save();
  ctx.clip(shape);
  ctx.setTransform(1, 0, 0, 1, 0, 0);          /* the clip is cut; the hatch is texels */
  ctx.drawImage(hatchCache(R), 0, 0);
  ctx.restore();

  ctx.strokeStyle = INK.profile;
  ctx.lineWidth = INK.profileW / k;             /* non-scaling: texels, not units */
  ctx.stroke(shape);

  var dt = liveDates(), td = dt && dt.today ? dnum(dt.today) : null;
  /* SB5 (2026-10-01): THE UNSURVEYED, EAST OF TODAY. The print hatches the
     future from its own baked front at x 1619, and that rect sat outside the
     strata's group, so `blankSection` never turned it off: it showed through
     at the same place on the paper at every pan, its cut west edge reading as
     a second dotted line (Tommy: "what are the extra dotted lines on the
     section all about?"). It is blanked now and struck here instead, from the
     live front to the cut, in the print's own pattern (sv-unsurveyed-f: 9
     apart at 45 degrees, the tile-clipped half of a 0.55 line).
     SB6 (2026-10-01): AND NO LINE AT TODAY. The live front was a pecked rule
     at today, but the seven-day mean runs on five days past it before the
     ground reaches the floor, so the rule marked nothing the eye could see
     and read as one more unlabelled dotted line among the labelled horizons.
     Tommy: "I just don't see the point it plays ... Why would someone need
     to know where today is?" It is gone, and the hatch begins where the
     ground meets the floor: the first day whose window [d-5, d+1] holds
     nothing after today, td + 6. */
  if (td !== null && td + 6 <= bc) {
    var ue = td + 6, ux = ue < a ? P.x0 : P.x0 + W * ((ue - a) / (b - a));
    ctx.save();
    ctx.beginPath(); ctx.rect(ux, 816, P.cut - ux, 116); ctx.clip();
    ctx.globalAlpha = INK.unsurvA;
    ctx.strokeStyle = INK.unsurv;
    hatch(ctx, 45, 9, ux, 816, P.cut, 932, INK.unsurvW, INK.unsurvW / 2);
    ctx.restore();
  }
  ctx.textBaseline = 'alphabetic';
  ctx.textAlign = 'left';
  ctx.fillStyle = INK.month;
  ctx.font = secFont(INK.monthPx);
  ctx.letterSpacing = (INK.monthPx * INK.monthTrack).toFixed(4) + 'px';
  secTicks(a, b).forEach(function (t) {
    if (t[0] > bc) return;                      /* SB4: blank under the card */
    ctx.fillText(t[1], +(P.x0 + W * ((t[0] - a) / (b - a))).toFixed(2), 947);
  });

  /* N2: the horizons the struck span reaches, each ruled down the band at
     the x its own date falls on. The name goes east of its rule as the
     plate set it, and west when the rule is close enough to the panel's
     east edge that the name would run off the paper; two names that would
     overprint go on two rows, the later one under the earlier. */
  var HZ_ROWS = [815, 831], hzEnd = [-1e9, -1e9], hzDrawn = [];
  ctx.font = secFont(INK.hzPx);
  ctx.letterSpacing = (INK.hzPx * INK.hzTrack).toFixed(4) + 'px';
  liveHorizons().map(function (h) { return { name: String(h.name || ''), d: dnum(h.date) }; })
    .filter(function (h) { return h.name && h.d >= a && h.d <= bc; })
    .sort(function (p1, p2) { return p1.d - p2.d; })
    .forEach(function (h) {
      var hx = P.x0 + W * ((h.d - a) / (b - a)), room = horizonRoom(h.name);
      var east = hx + 4 + room <= P.note, left = east ? hx + 4 : hx - 4 - room, r, i;
      for (r = 0, i = 0; i < HZ_ROWS.length; i++) { if (left >= hzEnd[i]) { r = i; break; } }
      if (i === HZ_ROWS.length) r = hzEnd[0] <= hzEnd[1] ? 0 : 1;   /* the older of the two */
      hzEnd[r] = left + room;
      ctx.save();
      ctx.strokeStyle = INK.hzLine;
      ctx.lineWidth = INK.hzLineW / k;          /* non-scaling, and so is its peck */
      ctx.setLineDash([INK.hzDash[0] / k, INK.hzDash[1] / k]);
      ctx.beginPath();
      ctx.moveTo(+hx.toFixed(2), SEC.TOP); ctx.lineTo(+hx.toFixed(2), SEC.BOT);
      ctx.stroke();
      ctx.restore();
      ctx.fillStyle = INK.hz;
      ctx.textAlign = east ? 'left' : 'right';
      ctx.fillText(h.name.toUpperCase(), +(east ? hx + 4 : hx - 4).toFixed(2), HZ_ROWS[r]);
      hzDrawn.push({ name: h.name, day: h.d, x: +hx.toFixed(2), y: HZ_ROWS[r], east: east });
    });
  SEC_HZ = hzDrawn;

  /* the note the printed panel carries (`sheet.section_note`), with the
     span it is actually drawn across written into it. */
  ctx.fillStyle = INK.note;
  ctx.font = secFont(INK.notePx);
  ctx.letterSpacing = '0px';
  ctx.textAlign = 'right';
  ctx.fillText(RoomCopy.t('sheet.section_note', {
    from: shortDate(isoAt(Math.round(a))),
    to: shortDate(isoAt(Math.round(b)))
  }), P.note, 801);
  return true;
}

/* ==== TM1 (2026-09-24): AT SEA THE SECTION IS THE WHOLE PASSAGE =======
   Tommy, of the section along the line west of the record: "all just
   empty sea" — the mean out there is nought, so the profile was the datum
   and nothing else. And of what it could be: "the section almost is a
   form of treasure map or something, but I don't think we'd have an X
   mark to spot. I think it's quite neat!"

   So when the view is wholly out at sea (its east end west of the
   harbour) the panel stops being a section of the ground under the
   screen and is laid out as the WHOLE PASSAGE, the berth at 12 April 1986
   at its west end and the harbour at its east, on its own even scale of
   days. On it, in the voyage's own drawings (lm-art.js, the same inks and
   the same art the chart's marks are cut from, side-on as they were
   drawn): the berth (VY2: the dot she goes out as) and the harbour at the two ends; every mark the
   reader has CHARTED, at its year, and a gap where one is still to be
   found — the gaps are the treasure; the boat where she is, in whichever
   boat she is in (BT2), and none once she has gone out at the berth. The boat is a way back to her: a
   click on her takes the view to her (`RoomVoyage.look`), through an
   invisible box laid over her on the paper (`seaHitLay`). The years along
   the foot are every fifth one. The vertical means nothing here — the
   drawings stand on the datum as the coast stands on the sea. ==== */
var SEA_HIT = null, SEA_S = 3.2, SEA_BOAT = SEA_S * 2.5 / 3.7;   /* art->root units: the marks', and hers (3.2: a drawing ~60 of the ~120 units above the datum) */
var SEA_INK = { water: '#4a7079', waterA: 0.5, red: '#96322a', ink: '#2b4249' };   /* VY2: the track's ink, for the dot   /* the X's red, the index's own */
/* ==== SB3 (2026-09-24): UNDER THE CARD ==================================
   The day's card lies over the section's east end from x ~1941 (the same
   rectangle of paper at every window, day.js E9). At sea the panel runs its
   full width again and that strip is used, hidden: the harbour just inside
   the card's west edge (she sails out from under it), then the land the
   record made, the harbour to today, then the downs east of the front and
   the pit at mid-2030 — its funnel dropping through the floor, or, once it
   has been aligned (`doom`), a peak up through the top. Seen only when the
   card slides off for a find. Tommy: "under the card, we have something
   like the harbour, a landmass, and then we show the singularity all
   hidden by the card, only revealed on the peek", and of the scale: "Just
   harbour and then land, then singularity would do the job." So the
   places are loose (the harbour ~4 years back, the pit ~4 ahead, today
   about the card's middle), not dates on a scale. ==== */
var SEA_X1 = 2242;               /* the rules' own east end: the full panel at sea */
var SEA_HX = 2030;               /* the harbour, just inside the card */
var SEA_LX = 2054;               /* the land's cliff, east of the harbour's drawing */
var SEA_TX = 2135;               /* today */
var SEA_PX = 2205, SEA_LIP = 16; /* the pit, and its lip's half-width */
var SEA_LIFT = 30, SEA_LAND_K = 0.35;   /* the land's shore height, and its record's */
var SEA_NEEDLE = 786;            /* the peak's tip: the panel's own top rule */
function seaDoom() {
  try { return !!(window.Room && Room.progress && Room.progress.has && Room.progress.has('doom')); }
  catch (e) { return false; }
}
function seaUnder(ctx, R, vs) {
  var k = R.k, Y0 = SEC.Y0, map = liveCounts(), lad = ladder(), dt = liveDates();
  var d0 = dnum(vs.to), d1 = dt && dt.today ? dnum(dt.today) : d0 + 1;
  if (d1 <= d0) d1 = d0 + 1;
  var up = seaDoom(), base = Y0 - SEA_LIFT, i, N = 48;
  /* a month's mean, not a week's: four years in ~80 units is land, not a chart */
  function land(d) {
    var m = 0, j;
    if (map) for (j = -14; j <= 14; j += 7) m += meanAt(Math.round(d) + j, map) / 5;
    return base - (Y0 - secY(lad.to(m))) * SEA_LAND_K;
  }
  function downs(x) { return base - 5 - 2.5 * Math.sin((x - SEA_TX) / 7); }
  var xl = SEA_PX - SEA_LIP, xr = SEA_PX + SEA_LIP, gl = downs(xl), gr = downs(xr);
  var shape = new Path2D();
  /* west of the pit: the cliff, the record, the downs, and the pit's west side */
  shape.moveTo(SEA_LX - 5, Y0);
  shape.lineTo(SEA_LX, land(d0));
  for (i = 1; i <= N; i++) shape.lineTo(SEA_LX + (SEA_TX - SEA_LX) * i / N, land(d0 + (d1 - d0) * i / N));
  for (i = SEA_TX + 2; i < xl; i += 2) shape.lineTo(i, downs(i));
  shape.lineTo(xl, gl);
  if (up) {
    /* aligned: the pit stood up into a peak, through the panel's top */
    shape.quadraticCurveTo(SEA_PX - 1.5, gl, SEA_PX, SEA_NEEDLE);
    shape.quadraticCurveTo(SEA_PX + 1.5, gr, xr, gr);
  } else {
    /* the funnel: flat at the lip, then plunging through the floor */
    shape.quadraticCurveTo(SEA_PX - 2, gl + 2, SEA_PX - 1, Y0);
    shape.closePath();
    shape.moveTo(SEA_PX + 1, Y0);
    shape.quadraticCurveTo(SEA_PX + 2, gr + 2, xr, gr);
  }
  for (i = Math.ceil(xr + 2); i < SEA_X1; i += 2) shape.lineTo(i, downs(i));
  shape.lineTo(SEA_X1, downs(SEA_X1));
  shape.lineTo(SEA_X1, Y0);
  shape.closePath();
  ctx.save();
  ctx.beginPath(); ctx.rect(SEA_HX, SEC_PANEL.y, SEA_X1 - SEA_HX, Y0 - SEC_PANEL.y); ctx.clip();
  ctx.save();
  ctx.clip(shape);
  ctx.setTransform(1, 0, 0, 1, 0, 0);          /* the clip is cut; the hatch is texels */
  ctx.drawImage(hatchCache(R), 0, 0);
  ctx.restore();
  ctx.strokeStyle = INK.profile; ctx.lineWidth = INK.profileW / k;
  ctx.lineJoin = 'round'; ctx.lineCap = 'round';
  ctx.stroke(shape);
  if (!up) {
    /* the hachures of the funnel, every one drawn in toward the throat */
    ctx.lineWidth = INK.strataW / k;
    ctx.beginPath();
    for (i = 1; i <= 5; i++) {
      var t = i / 6, u = 1 - t, sgn;
      for (sgn = -1; sgn <= 1; sgn += 2) {
        var qx = u * u * (SEA_PX + sgn * SEA_LIP) + 2 * u * t * (SEA_PX + sgn * 2) + t * t * (SEA_PX + sgn);
        var qy = u * u * (sgn < 0 ? gl : gr) + 2 * u * t * ((sgn < 0 ? gl : gr) + 2) + t * t * Y0;
        var ex = SEA_PX - qx, ey = Y0 + 6 - qy, el = Math.sqrt(ex * ex + ey * ey) || 1, len = 3 + 3 * u;
        ctx.moveTo(qx + sgn * 1.5, qy); ctx.lineTo(qx + sgn * 1.5 + ex / el * len, qy + ey / el * len);
      }
    }
    ctx.stroke();
  }
  ctx.restore();
}
function seaCanvas(ctx, R, a, b, vs) {
  var P = { x0: secPlot().x0, x1: SEA_X1 }, W = P.x1 - P.x0, k = R.k, L = window.RoomLmArt;
  /* SS1 (2026-09-26): the passage on a scale of STATIONS, not days. On an
     even scale of days the wreck (January 2022) and the harbour stood on
     top of each other at the east end with the boat between them; Tommy:
     "the harbour, and then the shipwreck, and the position of your little
     boat when you find the shipwreck is incredibly cramped". So the
     passage's start, each mark (charted or not, so nothing moves as they
     are found) and the harbour get an equal share of the panel, the day
     running evenly within each share; the berth keeps half a share of
     open sea to the west, and the harbour stays at SEA_HX under the card. */
  var H = dnum(vs.to), KD = [dnum(vs.from)];
  vs.marks.forEach(function (m) { KD.push(dnum(m.date)); });
  KD.push(H);
  KD = KD.filter(function (d) { return d <= H; }).sort(function (p, q) { return p - q; })
         .filter(function (d, i, o) { return !i || d > o[i - 1]; });
  /* BX1 (2026-09-26): the open sea west of the passage's start is a
     tenth of a share, not a half. Tommy: "the section has the 'final x'
     of the berth quite far from the left hand side? could it not be like
     75% closer?" */
  var LEAD = 0.1;
  var KS = (SEA_HX - P.x0) / (KD.length - 1 + LEAD);
  function X(d) {
    d = Math.min(d, H);
    if (d <= KD[0]) return P.x0 + KS * (LEAD + (d - KD[0]) / 840);
    for (var i = 1; i < KD.length; i++) if (d <= KD[i])
      return P.x0 + KS * (i - 1 + LEAD + (d - KD[i - 1]) / (KD[i] - KD[i - 1]));
    return SEA_HX;
  }
  ctx.setTransform(k, 0, 0, k, -R.px, -R.py);
  /* the sea's own level, the one line the empty panel had */
  ctx.save();
  ctx.globalAlpha = SEA_INK.waterA; ctx.strokeStyle = SEA_INK.water; ctx.lineWidth = 1 / k;
  ctx.beginPath(); ctx.moveTo(P.x0, SEC.Y0); ctx.lineTo(P.x1, SEC.Y0); ctx.stroke();
  ctx.restore();
  seaUnder(ctx, R, vs);
  ctx.save();
  ctx.beginPath(); ctx.rect(P.x0, SEC.TOP, W, SEC.BOT - SEC.TOP); ctx.clip();
  function sketch(key, x, sc, mode) {
    if (!L || !L.drawLandmark) return;
    ctx.save();
    ctx.translate(x, SEC.Y0 - 4.5 * sc); ctx.scale(sc, sc);
    ctx.lineJoin = 'round'; ctx.lineCap = 'round';
    L.drawLandmark(ctx, key, mode);
    ctx.restore();
  }
  /* XS1: the berth's drawing (VY2: a dot) only once she has been there; until then the berth
     is a cross in the red — X marks the spot (Tommy: "an 'X marks the
     spot' at the end for treasure that reveals itself to be the berth
     when you get there") */
  /* VY2 (2026-09-26): the reeds are gone — she goes out at the berth as a
     dot, so once she has, the cross is struck for the dot she went out as */
  if (vs.berthMade) {
    ctx.save();
    ctx.fillStyle = SEA_INK.ink;
    ctx.beginPath(); ctx.arc(X(dnum(vs.berth)), SEC.Y0 - 13, 2.6, 0, Math.PI * 2); ctx.fill();
    ctx.restore();
  } else {
    var xb = X(dnum(vs.berth)), xr = 6.5, xy = SEC.Y0 - 13;
    ctx.save();
    ctx.strokeStyle = SEA_INK.red; ctx.lineWidth = 2.2 / k; ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(xb - xr, xy - xr); ctx.lineTo(xb + xr, xy + xr);
    ctx.moveTo(xb + xr, xy - xr); ctx.lineTo(xb - xr, xy + xr);
    ctx.stroke();
    ctx.restore();
  }
  sketch('harbour', X(dnum(vs.to)), SEA_S, (vs.mode && vs.mode.harbour) || 'land');
  vs.marks.forEach(function (m) {
    if (!m.charted) return;                      /* a gap: still to be found */
    var x = X(dnum(m.date));
    m.cells.forEach(function (c) {
      /* a mark's cells stand apart on the chart by map units; here by a
         fortieth of that, in art units, so the two rocks stay two */
      sketch(c[0], x + c[1] / 40 * SEA_S, SEA_S * c[2], (vs.mode && vs.mode[c[0]]) || 'land');
    });
  });
  SEA_HIT = null;
  /* BT2: in the boat she is in now (the lugger is retired); VY2: and not
     at all once she has gone out at the berth */
  var bx = X(dnum(vs.boat));
  if (vs.state !== 'arrived') sketch(vs.vessel || 'lifeboat', bx, SEA_BOAT, 'afloat');
  if (vs.state !== 'arrived') {
    var hw = Math.max(12, 8 * SEA_BOAT), hh = Math.max(16, 11 * SEA_BOAT);
    SEA_HIT = { x: bx - hw, y: SEC.Y0 - hh, w: 2 * hw, h: hh + 4 };
  }
  ctx.restore();
  /* SB1 (2026-09-24): no bracket over the screen's stretch. Tommy: "The
     boat itself moving is more than you need, without just having this
     weird red box like the one that's on the index." */
  /* every fifth year along the foot */
  ctx.textBaseline = 'alphabetic'; ctx.textAlign = 'center';
  ctx.fillStyle = INK.month; ctx.font = secFont(INK.monthPx);
  ctx.letterSpacing = (INK.monthPx * INK.monthTrack).toFixed(4) + 'px';
  var y0 = +vs.from.slice(0, 4), y1 = +vs.to.slice(0, 4), y;
  for (y = Math.ceil((y0 + 1) / 5) * 5; y <= y1; y += 5) {
    ctx.fillText(String(y), +X(dnum(y + '-01-01')).toFixed(2), 947);
  }
  SEC_HZ = [];
  ctx.fillStyle = INK.note; ctx.font = secFont(INK.notePx);
  ctx.letterSpacing = '0px'; ctx.textAlign = 'right';
  ctx.fillText(RoomCopy.t('sheet.section_note_sea', {
    from: shortDate(vs.from), to: shortDate(vs.to)
  }), secPlot().note, 801);                      /* the note ends west of the card */
  return true;
}
/* is the section the passage? — she is under way and on the screen, or the view is out at sea */
function seaVoy(sp) {
  var V = window.RoomVoyage;
  if (!V || !V.sketches || !sp) return null;
  var vs = V.sketches();
  /* SB3: the passage from the moment she is under way (Tommy: "We should
     switch immediately when we go to the voyage") — SB4 (2026-09-25): but
     only while she is ON the screen. Dragged back to the record, the view
     is off the voyage and the section is the ground's again (Tommy: "if you
     drag out of the voyage it stays as the voyage's cross-section, not the
     normal one"). Out at sea it is the passage whether she is there or not. */
  if (!vs) return null;
  var bd = dnum(vs.boat), onScreen = vs.state !== 'moored' && bd >= sp[0] && bd <= sp[1];
  return onScreen || sp[1] < dnum(vs.to) ? vs : null;
}
function seaKey(vs) {
  var dt = liveDates();
  return Math.round(dnum(vs.boat) / 2) + ':' + vs.state + ':' + (vs.berthMade ? 'B' : 'X') + ':' +
    (seaDoom() ? 'P' : 'F') + ':' + (dt && dt.today ? dt.today : '') + ':' +
    vs.marks.map(function (m) { return m.charted ? 1 : 0; }).join('');
}
/* THE WAY BACK TO HER: one invisible box over the boat in the panel, in an
   svg laid on the paper exactly as the year index is (`Room.onPaperQuad`),
   in the panel's own root units. Only there while she is drawn in it. */
var seaSvg = null, seaBox = null, seaMat = '', seaRect = '';
function seaHitBuild() {
  var host = document.getElementById('sheet-index');
  if (!host || !host.parentNode) return false;
  var NS = 'http://www.w3.org/2000/svg';
  seaSvg = document.createElementNS(NS, 'svg');
  seaSvg.setAttribute('class', 'sheet-index sheet-seahit');
  seaSvg.setAttribute('aria-hidden', 'true');
  seaSvg.setAttribute('viewBox', SEC_PANEL.x + ' ' + SEC_PANEL.y + ' ' + SEC_PANEL.w + ' ' + SEC_PANEL.h);
  seaSvg.setAttribute('width', SEC_PANEL.w); seaSvg.setAttribute('height', SEC_PANEL.h);
  seaBox = document.createElementNS(NS, 'rect');
  seaBox.setAttribute('class', 'sx-boat');
  seaSvg.appendChild(seaBox);
  host.parentNode.appendChild(seaSvg);
  var down = null, moved = 0;
  function held() {
    var c = window.Room && Room.cardPresented ? Room.cardPresented() : null;
    return !!(c && c.discovery === true);
  }
  seaBox.addEventListener('pointerdown', function (e) {
    if (held()) return;                       /* the card has the hand */
    e.stopPropagation(); e.preventDefault();
    down = { x: e.clientX, y: e.clientY }; moved = 0;
  });
  seaBox.addEventListener('pointermove', function (e) {
    if (!down) return;
    moved += Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y);
    down = { x: e.clientX, y: e.clientY };
  });
  seaBox.addEventListener('pointerup', function (e) {
    if (!down) return;
    down = null; e.stopPropagation();
    if (moved <= 4 && window.RoomVoyage && RoomVoyage.look) RoomVoyage.look();
  });
  return true;
}
function seaHitLay() {
  if (!seaSvg && !seaHitBuild()) return;
  var hit = secCur && secCur.vs ? SEA_HIT : null;
  var live = !(window.Room && Room.mapLive && !Room.mapLive());
  var m = hit && live ? Room.onPaperQuad(SEC_PANEL.x, SEC_PANEL.y, 1, SEC_PANEL.w, SEC_PANEL.h) : null;
  if (m === null) { if (seaSvg.style.visibility !== 'hidden') seaSvg.style.visibility = 'hidden'; return; }
  if (seaSvg.style.visibility) seaSvg.style.visibility = '';
  if (m !== seaMat) { seaMat = m; seaSvg.style.transform = m; }
  var r = hit.x.toFixed(1) + ',' + hit.y.toFixed(1) + ',' + hit.w.toFixed(1) + ',' + hit.h.toFixed(1);
  if (r !== seaRect) {
    seaRect = r;
    seaBox.setAttribute('x', hit.x.toFixed(1)); seaBox.setAttribute('y', hit.y.toFixed(1));
    seaBox.setAttribute('width', hit.w.toFixed(1)); seaBox.setAttribute('height', hit.h.toFixed(1));
  }
  if (!seaSvg.classList.contains('is-laid')) seaSvg.classList.add('is-laid');
}

/* ---- struck into the sheet's own print ------------------------------
   `Room.furnPatch` copies the pristine print of the panel's region into
   one scratch canvas, hands it to `secDraw` to draw the moving parts
   over, and sub-images the result into the furniture texture.

   SL1 (2026-09-22) MADE THE STRIKE SYNCHRONOUS. It used to be an SVG
   rastered through an <img> off a Blob URL (engine.js's viaImage idiom),
   which is asynchronous: a strike carried a generation and a stale one
   was dropped on landing. The raster was nearly the whole of the cost —
   6-56 ms a strike, and 1.5 s for the first two in a page while Chrome
   warmed its SVG-image machinery — which is why the section could only
   be struck on a settle. Drawn with Canvas 2D there is no image, no
   decode and no warm-up: the strike is a few hundred lines and some
   lettering into a canvas that is already there, so it can be struck on
   any frame the span moves, and it is (see `lay`). Nothing else changed:
   the same region, the same `furnPatch`, the same texels. `secDraw` is
   what furnUpload re-applies after the print is re-cut, and because it
   draws to whatever region it is handed, a re-cut at another scale needs
   no fresh strike of its own. */
var secKey = '', secTry = 0, secSpan = null, secCur = null;
var SEC_HZ = [];                    /* N2: the horizons the last strike ruled */
var secDrawMs = 0;
function secDraw(ctx, R) {
  if (!secCur) return;
  var t = (window.performance && performance.now) ? performance.now() : 0;
  secCanvas(ctx, R, secCur.a, secCur.b, secCur.vs);
  if (t) secDrawMs = performance.now() - t;
}
/* WHEN IT IS RE-STRUCK: on any frame the span has moved (SL1), and on the
   settle, which is the moment engine.js writes the hash — the settle is
   no longer the only strike but it is still the one that GUARANTEES the
   last picture is the struck one. Never on a tab nobody is looking at,
   and never when the span has not moved: a tilt, a fold, a wheel that
   changed nothing and a still frame all come out of the key unchanged
   and cost one string. `secMs` is the whole of it: the draw, the
   composite and the upload. */
var secMs = 0, secN = 0, secSlow = 0, SEC_BUDGET = 4;
function restrikeSection() {
  if (document.hidden) return false;
  if (!window.Room || !Room.furnRegion) return false;
  var R = Room.furnRegion(SEC_PANEL.x, SEC_PANEL.y, SEC_PANEL.w, SEC_PANEL.h);
  if (!R) return false;                         /* no print yet: nothing to strike into */
  if (secFace === null) { secFaceLoad(); return false; }
  if (!secFaceOn) return false;                 /* the face is decoding; it will call back */
  var sp = viewSpan();
  if (!sp) return false;
  var vs = subject ? null : seaVoy(sp);          /* TM1: a stranger's record has no passage */
  /* at sea the passage does not depend on the view's span (SB1), so a pan
     out there restrikes nothing */
  var key = (vs ? 'sea:' + seaKey(vs) : sp[0].toFixed(2) + ':' + sp[1].toFixed(2)) +
            ':' + (subject ? subject.handle : '.') + ':' + R.pw + 'x' + R.ph;
  if (key === secKey) return true;
  var t0 = (window.performance && performance.now) ? performance.now() : 0;
  var was = secCur;
  secCur = { a: sp[0], b: sp[1], vs: vs };
  secDrawMs = 0;
  if (!Room.furnPatch(SEC_PANEL.x, SEC_PANEL.y, SEC_PANEL.w, SEC_PANEL.h, secDraw)) {
    secCur = was; return false;
  }
  var t1 = t0 ? performance.now() : 0;
  secKey = key; secN++;
  if (t0) { secMs = +(t1 - t0).toFixed(2); secSlow = secMs > SEC_BUDGET ? 1 : 0; }
  secSpan = { a: sp[0], b: sp[1], from: isoAt(Math.round(sp[0])), to: isoAt(Math.round(sp[1])),
              months: secTicks(sp[0], sp[1]).map(function (t) { return t[1]; }),
              horizons: SEC_HZ, n: secN, slow: secSlow, sea: !!vs,
              boatHit: vs && SEA_HIT ? [SEA_HIT.x, SEA_HIT.y, SEA_HIT.w, SEA_HIT.h] : null,
              texels: [R.px, R.py, R.pw, R.ph],
              /* the strike in its two parts: the drawing, and the copy-in,
                 composite and texSubImage2D around it */
              ms: t0 ? [+secDrawMs.toFixed(2), +(t1 - t0 - secDrawMs).toFixed(2)] : null };
  return true;
}
function onViewSettled() {
  try { return restrikeSection(); } catch (e) { return false; }
}

/* ---- and the printed panel's moving parts, turned off ---------------
   SB5 (2026-10-01): an inline STYLE, not the attribute. The frame's own
   stylesheet sets `.sv-section-front { opacity: 0.75 }`, and in SVG a
   stylesheet rule beats a presentation attribute, so the baked front line
   at x 1619 was never turned off: it stood at the same place on the paper
   at every pan (Tommy: "one of the lines ... seems to be fixed in place").
   An inline style beats the class whatever the stylesheet says.
   Turned off, not cut out: `opacity` 0 leaves every node where it was
   so the clipPath the strata are hatched inside is still a real path and
   the file's own arithmetic is untouched. If the page carries no record
   at all there is nothing for the overlay to draw and the print stands. */
function blankSection(s) {
  if (!document.getElementById('survey-data')) return s;
  s = s.replace(/<path d="([^"]*)" class="sv-section-profile"/,
                '<path style="opacity:0" d="$1" class="sv-section-profile"');
  s = s.replace('<g clip-path="url(#sv-sec-clip)">', '<g style="opacity:0" clip-path="url(#sv-sec-clip)">');
  s = s.replace(/<line ([^>]*class="sv-section-front")/, '<line style="opacity:0" $1');
  /* SB5: and the print's unsurveyed hatch, which stood outside that group */
  s = s.replace(/<rect ([^>]*fill="url\(#sv-unsurveyed-f\)")/, '<rect style="opacity:0" $1');
  s = s.replace(/<text ([^>]*class="sv-section-month")/g, '<text style="opacity:0" $1');
  s = s.replace(/<text ([^>]*class="sv-section-note")/, '<text style="opacity:0" $1');
  /* N2: and the horizons, which were print at the print's own fixed span
     and are struck live now — both the pecked rule and the name. */
  s = s.replace(/<line ([^>]*class="sv-horizon-line")/g, '<line style="opacity:0" $1');
  s = s.replace(/<text ([^>]*class="sv-section-horizon")/g, '<text style="opacity:0" $1');
  return s;
}

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
              'August', 'September', 'October', 'November', 'December'];
var SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function longDate(iso) {
  var d = new Date(Date.parse(iso + 'T00:00:00Z'));
  return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
}
function shortDate(iso) {
  var d = new Date(Date.parse(iso + 'T00:00:00Z'));
  return d.getUTCDate() + ' ' + SHORT[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
}
function swapText(s, cls, text) {
  var re = new RegExp('(<text[^>]*class="[^"]*' + cls + '[^"]*"[^>]*>)([\\s\\S]*?)(<\\/text>)');
  return s.replace(re, function (all, open, was, close) { return open + esc(text) + close; });
}

function prepFurniture(s) {
  s = blankSection(s);          /* S3: what the live strike draws is not printed */
  if (!editing && subject === null) return s;   /* THE DEFAULT PAGE, OTHERWISE UNTOUCHED */
  if (editing) {
    /* turned off, not cut out — index.js's measurement */
    s = s.replace(/<text ([^>]*class="sv-cart-name")/, '<text opacity="0" $1');
    if (subject === null) return s;
  } else {
    /* R69: the size is the LOCAL unit the cartouche's own CSS is written
       in (`calc(40px * var(--cu))`), so it is written back as it is — the
       `/ CU` that used to stand here is the whole of the overflow. */
    var L = layoutName(printedRaw || printed || '');
    s = s.replace(NAME_RE, function (all, open, was, close) {
      if (L.px < NAME_PX * CU - 0.01)
        open = open.replace(/<text /, '<text style="font-size:' + L.px.toFixed(3) + 'px" ');
      if (L.lines.length === 1 && L.lines[0].y === null) return open + esc(L.lines[0].t) + close;
      /* two lines are two tspans on the text's own x, each with the
         baseline solved for the band; the <text>'s own y is left where it
         was printed so nothing else in the group moves. */
      var inner = '';
      for (var i = 0; i < L.lines.length; i++) {
        var ln = L.lines[i];
        inner += '<tspan x="960" y="' + (ln.y === null ? BASE + BOX.y : ln.y).toFixed(4) + '">' +
                 esc(ln.t) + '</tspan>';
      }
      return open + inner + close;
    });
  }
  if (subject === null) return s;

  /* ---- the four figures --------------------------------------------- */
  var to = subject.surveyedTo, today = subject.today;
  /* HM1 (2026-10-02): "Surveyed to" and the range at the top right are
     struck live by engine.js (SV1's survText / rangeText) from whichever
     record is up, so they are NOT also printed into the frame here: doing
     both lettered each note twice, one over the other, on a stranger's
     sheet (found by the overnight audit, torvalds and knadh). */
  /* the tally note is gone with the rest (see above) */

  /* ---- B4: AND THE MARGIN NO LONGER SAYS WHAT A DAY IS WORTH -------
     Tommy, 2026-09-19: "drop the two lines about the level of a directed
     versus non-directed day". Both are gone from sheet-frame.svg — the
     `--mhw` line above and R70's sea-level sentence that used to be
     re-struck here — so there is nothing left in the bottom right to
     re-strike but the source line and the tally. The ladder is still read
     here because the section's own figures below are struck from it. */
  var lad0 = ladder();

  /* ---- R70: the section's own figures, in this record's commits ------
     Five <text> nodes share the class `sv-section-fig`, so they are found
     by the y they are set on (each is distinct and baked) rather than by
     class — swapText would only ever reach the first of them. */
  var lad = lad0;
  if (!lad.id) {
    SEC_FIGS.forEach(function (v, i) {
      var re = new RegExp('(<text x="116" y="[\\d.]+" class="sv-section-fig" text-anchor="end">)' +
                          v + '(</text>)');
      s = s.replace(re, '$1' + secFig(v, lad) + '$2');
    });
  }

  /* ---- the section, redrawn ----------------------------------------- */
  var d = to ? sectionPath(to) : null;
  if (d) {
    /* the profile, and the clip the strata are hatched inside — one shape,
       two places, as the baked file has it */
    s = s.replace(/(<path d=")[^"]*(" class="sv-section-profile")/, '$1' + d + '$2');
    s = s.replace(/(<clipPath id="sv-sec-clip"><path d=")[^"]*(")/, '$1' + d + '$2');
    if (today) {
      var fx = secX(dnum(today)).toFixed(4);
      s = s.replace(/(<line )x1="[\d.]+"( y1="[\d.]+" )x2="[\d.]+"( y2="[\d.]+" class="sv-section-front")/,
                    '$1x1="' + fx + '"$2x2="' + fx + '"$3');
    }
  }
  return s;
}

/* ---- THE ELEMENT --------------------------------------------------- */
function build() {
  hit = document.createElement('div');
  hit.className = 'sh-hit';
  hit.setAttribute('title', '');
  ed = document.createElement('div');
  ed.className = 'sh-edit';
  ed.setAttribute('spellcheck', 'false');
  ed.setAttribute('autocorrect', 'off');
  ed.setAttribute('autocapitalize', 'off');
  /* CX1: the deletion mark and the strike. Both are laid from the NAME's
     own measure (`nameGeom`), not from the box the name is centred in. */
  dele = document.createElement('div');
  dele.className = 'sh-dele';
  dele.innerHTML = DELE_SVG;
  strike = document.createElement('div');
  strike.className = 'sh-strike';
  root.appendChild(hit); root.appendChild(ed); root.appendChild(dele); root.appendChild(strike);
  OFF = BOX.y - TOP;
  root.style.width = BOX.w + 'px';
  root.style.height = (BOX.y + BOX.h - TOP) + 'px';
  hit.style.top = OFF + 'px';
  hit.style.height = BOX.h + 'px';
  /* A HAND THAT MOVED IS NOT A PUSH -- the cartouche's own rule, kept, so
     a drag that happens to begin on the mark pans nothing and rubs
     nothing out. */
  var bd = null, bmv = 0;
  dele.addEventListener('pointerdown', function (e) {
    e.stopPropagation(); e.preventDefault();
    bd = { x: e.clientX, y: e.clientY }; bmv = 0;
  });
  dele.addEventListener('pointermove', function (e) {
    if (!bd) return;
    bmv += Math.abs(e.clientX - bd.x) + Math.abs(e.clientY - bd.y);
    bd = { x: e.clientX, y: e.clientY };
  });
  dele.addEventListener('pointerup', function (e) {
    if (!bd) return;
    bd = null; e.stopPropagation();
    if (bmv > 4) return;
    restore();
  });
  dele.addEventListener('pointercancel', function () { bd = null; });
  dele.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); });
  size(NAME_PX * CU);

  /* A HAND THAT MOVED IS NOT A PUSH — index.js's rule for the year cells,
     kept, so a drag that happens to start on the cartouche does not open
     the editor under it. (The drag still does not PAN: engine.js's
     `onGlass` has always held that a pointer on a thing is not a pointer
     on the ground, and this box is a thing. It is 237 x 23 css px at the
     fit, in the sheet's foot margin, well below the plate — see OPEN 1.) */
  var down = null, moved = 0, pid = -1, downAt = 0;
  hit.addEventListener('pointerdown', function (e) {
    e.stopPropagation(); e.preventDefault();
    down = { x: e.clientX, y: e.clientY }; moved = 0; pid = e.pointerId;
    downAt = performance.now();
    try { hit.setPointerCapture(e.pointerId); } catch (err) { /* fine */ }
  });
  hit.addEventListener('pointermove', function (e) {
    if (!down) return;
    moved += Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y);
    down = { x: e.clientX, y: e.clientY };
  });
  hit.addEventListener('pointerup', function (e) {
    if (!down) return;
    down = null; e.stopPropagation();
    /* EG3: a fingertip wanders; on a phone a tap is under ten pixels */
    if (moved > (/(^|\s)phone(\s|$)/.test(document.documentElement.className) ? 10 : 4)) return;
    /* ==== PH9 (2026-10-02): SEND IT TO YOUR DESK. On the phone, the name
       pressed and held, then let go, hands the sheet to the phone's own
       share sheet, so a reader on a train can send it to the desk it is
       made for. Nothing on the sheet says so (no button, no word): a tap
       is still the name's own editor, a held press is the send. It fires
       on the RELEASE because Safari counts a touch's release, not its
       press, as the gesture that may open a share sheet. ==== */
    if (PHONE_SHARE && performance.now() - downAt >= 500) {
      try { navigator.share({ url: location.origin + '/' }).catch(function () { }); } catch (err) { }
      return;
    }
    edit(true);
  });
  /* ==== B4: AND EVERY OTHER WAY THE HAND CAN LEAVE THE CARTOUCHE =====
     B3's finding, applied here. The capture above is asked for inside a
     try/catch because it can simply not be given, and it can be taken
     away again afterwards: another element takes the pointer, the button
     is let go outside the window, the window loses focus mid-press, the
     tab is hidden. Until now only an up or a cancel arriving AT THIS BOX
     cleared `down` — and `down` with `moved` still at 0 is a push waiting
     to happen, because the up above asks nothing else. MEASURED before
     this card (room-rev10/b4-specs/before-175.json), on all four paths:
     the box kept `down`, and the next release to land anywhere on the
     cartouche opened the editor — the printed name blanked, the furniture
     rastered again and a caret in the sheet, for a hand that never pushed
     it. Every one of the four left `RoomHandle.editing()` true.

     The release is the up's half MINUS the open, because a hand that was
     taken away did not push the name. It does something only while this
     hand is still on the box, so the `lostpointercapture` that follows
     every ordinary release finds nothing to do; the window pair sits in
     the BUBBLE phase, below the box's own up, so a real release is still
     answered there first, with its open and its stopPropagation. Nothing
     runs per frame. ==== */
  function letGo(id) {
    if (id !== undefined && id !== pid) return;
    if (!down) return;
    down = null; moved = 0;
  }
  hit.addEventListener('pointercancel', function (e) { letGo(e.pointerId); });
  hit.addEventListener('lostpointercapture', function (e) { letGo(e.pointerId); });
  window.addEventListener('pointerup', function (e) { letGo(e.pointerId); });
  window.addEventListener('pointercancel', function (e) { letGo(e.pointerId); });
  /* the hand is now in another window or on another tab, and no pointer
     event of any kind is coming back */
  window.addEventListener('blur', function () { letGo(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) letGo(); });
  hit.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); });
  hit.addEventListener('dblclick', function (e) { e.stopPropagation(); });

  ed.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
  ed.addEventListener('keydown', function (e) {
    e.stopPropagation();
    if (e.key === 'Enter') { e.preventDefault(); commit(); }
    else if (e.key === 'Escape') { e.preventDefault(); edit(false); }
  });
  /* a hand that leaves the cartouche has changed its mind */
  ed.addEventListener('blur', function () { if (editing && !asking) edit(false); });
  ed.addEventListener('input', function () { size(sizeFor(ed.textContent || 'M')); });
}

/* THE EDITED NAME STANDS ON THE PRINTED NAME'S OWN BASELINE, and that is
   measured rather than guessed. A line box puts the baseline at
   (lineHeight - (ascent + descent)) / 2 + ascent from its top, and the two
   metrics are the FACE's, not the size's — so they are read off the same
   2d context the width is measured with (fontBoundingBoxAscent) and the
   padding is solved for the baseline the cartouche was printed at. Guessed
   at 0.74em it landed 1.5 css px low at the fit; measured it lands on it.
   ?cart=<dy> nudges it in over-layer units if a face ever disagrees. */
function size(px) {
  var asc = px * 0.75, desc = px * 0.25;
  if (!meas) widthOf('H', px);
  try {
    meas.font = px + 'px "Sorts Mill Goudy LN", "Sorts Mill Goudy", Georgia, serif';
    var m = meas.measureText('Hxy');
    if (m.fontBoundingBoxAscent) { asc = m.fontBoundingBoxAscent; desc = m.fontBoundingBoxDescent; }
  } catch (e) { /* the estimate stands */ }
  /* the line box hugs the letters, so the selection is a band on the name
     and not a panel across the cartouche */
  var lineH = asc + desc;
  ed.style.fontSize = px.toFixed(3) + 'px';
  ed.style.lineHeight = lineH.toFixed(3) + 'px';
  /* THE OFFSET IS NEGATIVE and has to be allowed to be: the face's ascent
     (30 px at this size, measured) is taller than the 24.55 units between
     the box's top and the printed baseline, so the line box starts ABOVE
     the box. It was `padding-top` at first, which CSS clamps at zero and
     silently threw the correction away — the edited name sat 8 device px
     (4.6 css px at the fit) below the printed one, measured off the two
     captures. `top` takes the negative, and the box is absolute. */
  var top = OFF + BASE - (lineH - (asc + desc)) / 2 - asc + TUNE;
  ed.style.top = top.toFixed(2) + 'px';
  /* X6 (d) — AND THE SELECTION WASH IS CUT OFF UNDER THE EYEBROW (X4
     OPEN 2). The wash is painted over the text's GLYPH box — ascent above
     the baseline, descent below — and this face's ascent is 30 units where
     its cap height is 21, so the band stood 2.7 device px over the
     eyebrow's baseline and washed the feet of `A SURVEY OF THE WORKS OF`.

     THE LINE BOX IS NOT THE LEVER, and that is measured: `line-height` was
     clamped first and the painted band did not move (1153 -> 1152 device
     y, the build's own difference). Chrome floors the selection at the
     font's ascent + descent whatever the line box says. So it is CUT, not
     shortened — one `clip-path` inset from the element's own top, which
     clips paint and nothing else: the baseline does not move (the whole of
     X4's measurement), no contenteditable is made scrollable, no second
     element. The caps start 21 units over the baseline and the cut is 24.9
     above it, so only the band's empty shoulder goes; the caret goes with
     it, which is right, it was standing on the eyebrow too. Descenders are
     untouched — `tommy5dollar`'s y reaches 6 units down, the band 15. */
  var cut = (EYE + EYE_GAP - TOP) - top;
  ed.style.clipPath = cut > 0 ? 'inset(' + cut.toFixed(2) + 'px 0 0 0)' : 'none';
  ed.style.letterSpacing = (SPACING * px).toFixed(3) + 'px';
  ed.style.textIndent = (SPACING * px).toFixed(3) + 'px';   /* undo the trailing space */
}

/* ---- LAID ON THE PAPER, EVERY FRAME (index.js's own call) ---------- */
function lay(st) {
  S = st;
  /* S3: the FIRST strike is tried on one frame in thirty until the record
     is in and the print exists, so a page with no record in it costs
     nothing. It is in the texture, so there is nothing to lay.
     SL1: and after that the section FOLLOWS THE VIEW. The span is
     arithmetic on the camera (`viewSpan`), so asking for it every frame
     costs a few multiplies, and a frame whose span has not moved — a
     tilt, a fold, a still picture — comes out of `restrikeSection`'s key
     unchanged and draws nothing at all. The settle hook is still there
     and still guarantees the last picture is the struck one; it is no
     longer the only strike. THE CAP: if a strike came in over
     SEC_BUDGET ms the next one waits a frame, so the drawing can never
     take more than half the frames however slow the box is. */
  if (!secKey) { if ((secTry++) % 30 === 0) onViewSettled(); }
  else if (!secSlow || ((secTry++) & 1)) onViewSettled();
  /* RG1: and the top-right range line rides the same first strike */
  if (!secKey && window.Room && Room.strikeRange) { try { Room.strikeRange(); } catch (e) {} }
  try { seaHitLay(); } catch (e) { }                /* TM1: the boat in the panel */
  if (!root) return;
  var m = Room.onPaperQuad(sheetX(BOX.x), sheetY(TOP), OVER.k,
                           BOX.w, BOX.y + BOX.h - TOP);
  if (m === null) {
    if (root.style.visibility !== 'hidden') root.style.visibility = 'hidden';
    return;
  }
  if (root.style.visibility) root.style.visibility = '';
  if (m !== mat) { mat = m; root.style.transform = m; }
  if (!laid) { laid = 1; root.classList.add('is-laid'); }
  /* S-B2: whose record is on the desk — asked once a laid frame, written
     to the DOM only when the answer changes */
  var g = !!subject;
  if (g !== guest) {
    guest = g;
    root.classList.toggle('is-guest', g);
    if (g) placeDele();
  }
}

/* ---- CX1: WHERE THE NAME STANDS, in the element's own px ------------
   The printed name (or the typed one while editing), its set size, its
   widest line and the baseline the strike goes over. Two printed lines
   take the lower baseline and the wider line. */
function nameGeom() {
  var raw = editing ? (ed.textContent || '') : (printedRaw || printed || '');
  if (!raw) return null;
  var w, px, base;
  if (editing) {
    px = sizeFor(String(raw).toUpperCase());
    w = widthOf(String(raw).toUpperCase(), px);
    base = OFF + BASE + TUNE;
  } else {
    var L = layoutName(raw);
    px = L.px; w = 0;
    L.lines.forEach(function (l) { w = Math.max(w, widthOf(l.t, px)); });
    base = L.lines.length === 1 ? OFF + BASE : (L.lines[L.lines.length - 1].y - TOP);
  }
  return { w: w, px: px, base: base, cx: BOX.w / 2 };
}
/* the deletion mark sits off the CARTOUCHE's east end, its loop on the
   name's x-height.

   ==== DM1 (Tommy, 2026-09-23): "The mark we use to remove a GitHub
   handle and go back still isn't good enough. For this test GitHub
   handle, it renders in the middle of their name. Are we expanding the
   cartouche width based on name? I think maybe whatever we render should
   consistently be just to the right of the cartouche?" The box never
   changes shape (R69: the NAME is sized to fit it), and the mark was
   laid off the name's east end as `widthOf` measured it — a canvas
   measure in a face the canvas does not always have, so on his screen
   the measure came up short and the mark stood on the letters. The box
   is furniture with one width, so the mark is laid off THAT: a fixed
   distance east of the cartouche, whatever the name measures. Only its
   height still follows the name (the last line's baseline and size). ==== */
var DELE_GAP = 0.32;                  /* of the name's size, east of the box */
function placeDele() {
  var g = nameGeom();
  if (!g) return;
  var h = Math.max(9, g.px * 0.5);
  dele.style.left = (BOX.w + g.px * DELE_GAP).toFixed(2) + 'px';
  dele.style.top = (g.base - h * 0.92).toFixed(2) + 'px';
  dele.style.width = (h * 0.85).toFixed(2) + 'px';
  dele.style.height = h.toFixed(2) + 'px';
}
/* THE STRIKE: a pen rule through the name, drawn from the west end over
   `STRIKE_MS`, a little off level as a hand's is; it stays until `unstrike`
   fades it. Returns a promise that resolves when the rule has crossed. */
var STRIKE_MS = 260, FADE_MS = 300;
function strikeName() {
  var g = nameGeom();
  if (!g) return Promise.resolve();
  /* DM1: the rule is laid over the name's FIELD (FIT_W, the most a
     name may measure), not over `widthOf`'s reading of the name, for the
     reason the mark moved: the measure is not to be trusted on every
     machine. A pen rule that runs a little past a short name is a pen
     rule. */
  var pad = g.px * 0.12, fw = Math.max(g.w, FIT_W);
  strike.style.left = (g.cx - fw / 2 - pad).toFixed(2) + 'px';
  strike.style.width = (fw + pad * 2).toFixed(2) + 'px';
  strike.style.top = (g.base - g.px * 0.30).toFixed(2) + 'px';
  strike.style.height = Math.max(1.2, g.px * 0.055).toFixed(2) + 'px';
  root.classList.remove('is-rubbed');
  root.classList.add('is-struck');
  return new Promise(function (res) { setTimeout(res, STRIKE_MS + 60); });
}
function unstrike() {
  root.classList.add('is-rubbed');
  setTimeout(function () { root.classList.remove('is-struck'); root.classList.remove('is-rubbed'); }, FADE_MS + 40);
}

/* ---- THE EDIT ------------------------------------------------------ */
function edit(on) {
  on = !!on;
  if (on === editing) return;
  editing = on;
  root.classList.toggle('is-editing', on);
  if (on) {
    ed.textContent = subject ? subject.handle : 'tommy5dollar';
    size(sizeFor(ed.textContent));
    Room.refurnish().then(function () {
      if (!editing) return;
      ed.contentEditable = 'plaintext-only';
      if (ed.contentEditable !== 'plaintext-only') ed.contentEditable = 'true';
      ed.focus();
      var r = document.createRange(); r.selectNodeContents(ed);
      var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
    });
  } else {
    ed.contentEditable = 'false';
    ed.blur();
    Room.refurnish();
  }
}

/* CX1: THE RECORD GOES BACK. The stranger's name is struck through, the
   record reloads under the rule (`Room.load(null)`, the terminal's own
   call; its `setName(null)` takes the mark away), and the rule fades off
   the reprinted name. Nothing is said. */
function restore() {
  if (asking || !subject) return;
  asking = true;
  root.classList.add('is-asking');
  return strikeName().then(function () {
    return Room.load(null);
  }).then(function () {
    asking = false; root.classList.remove('is-asking');
    if (editing) edit(false);
    unstrike();
  }).catch(function () {
    asking = false; root.classList.remove('is-asking');
    unstrike();
  });
}

/* ==== WM2 — THE ENTER KEY, AS A FUNCTION =============================
   `commit` was the Enter key AND the decision it makes, and the decision
   is the interesting half: an empty box puts the record back, the name
   already on the sheet is no name at all, and anything else is a fetch.
   WM2 (2026-09-22) splits the two so an agent's `survey_act cartouche`
   presses the SAME key a reader does, guards and all, instead of reaching
   past them to `load`. Reaching past them would hand out the mark for
   typing the name that is already printed on the paper, and the mark is
   for somebody ELSE'S record — the guard is the egg.
   ==================================================================== */
function enter(h) {
  h = String(h == null ? '' : h).trim().replace(/^@/, '');
  /* S-B2: and a name rubbed out is a record put aside. Escape is still
     the way to change nothing at all. */
  if (!h) { if (subject) return restore() || null; edit(false); return null; }
  if (subject && h.toLowerCase() === subject.handle.toLowerCase()) { edit(false); return null; }
  if (!subject && h.toLowerCase() === 'tommy5dollar') { edit(false); return null; }
  return load(h);
}
function commit() {
  var p = enter(ed.textContent || '');
  if (p && p.catch) p.catch(function () { /* the miss has been struck through */ });
}

/* ---- THE ONE FETCH THIS PAGE EVER MAKES ---------------------------- */
function load(h) {
  if (asking) return Promise.reject(new Error('already asking'));
  asking = true;
  root.classList.add('is-asking');
  return fetch('/api/record/' + encodeURIComponent(h), { headers: { 'Accept': 'application/json' } })
    .then(function (r) {
      return r.json().catch(function () { return { error: RoomCopy.t('terminal.handle_quiet') }; })
        .then(function (j) { if (!r.ok) { var e = new Error(j.error || ('http ' + r.status)); e.world = j.world; throw e; } return j; });
    })
    .then(function (j) {
      return Room.load(j).then(function () {
        asking = false; root.classList.remove('is-asking');
        editing = true; edit(false);          /* the editor goes; the print stays */
        /* X6 (b): the egg is the sheet REDRAWN from somebody else's
           record, so the mark is struck here and not on the fetch — a
           handle that answers and then fails to draw has not been
           found. Both doors come through this one function (the
           cartouche's Enter and the terminal's `handle`), so there is
           one line and not two. */
        if (window.Room && Room.progress) Room.progress.mark('handle');
        return j;
      });
    })
    .catch(function (e) {
      asking = false; root.classList.remove('is-asking');
      /* CX1: NOT FOUND. The typed name is struck through in the revision
         red and rubbed out, and the printed name returns; a lookup from
         the terminal (no editor open) has nothing on the paper to strike
         and the terminal prints the reason itself. */
      if (editing) {
        strikeName().then(function () {
          root.classList.add('is-rubbing');
          return new Promise(function (res) { setTimeout(res, FADE_MS); });
        }).then(function () {
          edit(false);
          root.classList.remove('is-rubbing');
          unstrike();
        });
      }
      throw e;
    });
}

/* ---- WHAT ENGINE.JS CALLS ------------------------------------------ */
/* `Room.load` calls this with the display name of whoever's record landed,
   or null to put his own back. The PRINTED name follows from it. */
function setName(name) {
  if (!name) { subject = null; printed = null; printedRaw = null; return; }
  /* R69 keeps the name IN THE CASE IT ARRIVED IN as well: the cartouche
     is set in caps, and caps have no camel boundary left to break at. */
  printedRaw = String(name);
  printed = printedRaw.toUpperCase();
}
function setSubject(j) {
  CAL = null; secKey = '';         /* S3: another record, another epoch */
  if (!j) { subject = null; COUNTS = null; TALLY = 0; return; }
  ingest(j);
  subject = { handle: j.handle, name: j.name || j.handle, created: j.created,
              total: j.total, first: j.first, home: j.home,
              today: j.today, surveyedTo: j.surveyedTo, mhw: null };
}
/* the level of a directed day is the FIELD's, not the wire's: it is the
   median working day since the datum horizon, and only the worker knows it.
   engine.js hands it over the moment the field lands, before the furniture
   is rastered again. */
function setLevel(n) { if (subject) subject.mhw = n; }

function init(st) {
  S = st;
  root = document.getElementById('sheet-handle');
  if (!root) return;
  build();
}

window.RoomHandle = {
  init: init, lay: lay, prepFurniture: prepFurniture,
  /* S3: engine.js calls this the moment the view settles */
  onViewSettled: onViewSettled,
  /* SL1: the Canvas 2D strike's own ms -- the draw, the composite and the
     upload -- and how many have been struck since the page loaded, so a
     drag's whole cost can be read off two samples. */
  sectionMs: function () { return secMs; },
  sectionStrikes: function () { return secN; },
  /* the last strike's span, labels and texel rect, for the harness */
  sectionSpan: function () { return secSpan; },
  /* RG1: the view's own span in days from 1 Jan 2026, for the top-right range line */
  viewDays: viewSpan,
  setName: setName, setSubject: setSubject, setLevel: setLevel,
  subject: function () { return subject; },
  load: load,                    /* the terminal's `handle <name>` */
  enter: enter,                  /* WM2: the panel's own Enter key, guards and all */
  edit: edit,
  /* R69: the compositor's answer for a name, for measurement — a pure
     function of the string, drawing nothing. */
  layout: layoutName,
  editing: function () { return editing; }
};
})();
